import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Inter variable (wght axis, normal style), self-hosted from node_modules —
// no CDN, so it works offline in the Capacitor app.
import "@fontsource-variable/inter";
// Semantic design tokens (DESIGN.md) load before any stylesheet that uses them.
import "./styles/tokens.css";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import { AddressProvider } from "./hooks/useAddress";
import { ThemeProvider } from "./context/ThemeContext";
import { CartProvider } from "./context/CartContext";
import { UIProvider } from "./context/UIContext";
import { BusinessAuthProvider } from "./business/context/BusinessAuthContext";
import { MessagingProvider } from "./context/MessagingContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AddressProvider>
        <ThemeProvider>
          <CartProvider>
            <UIProvider>
              <BusinessAuthProvider>
                <MessagingProvider>
                  <App />
                </MessagingProvider>
              </BusinessAuthProvider>
            </UIProvider>
          </CartProvider>
        </ThemeProvider>
      </AddressProvider>
    </AuthProvider>
  </React.StrictMode>
);
